
/**
 * This function shortens the name of a user, for avatar uses. It also removed special characters
 * @param name Name of a user
 * @returns Shortned name of that user
 * @example
 * const userName = 'John - Doe'
 * const shortened = getShortName(userName)
 * console.log(shortened) // J
 */
export const getShortName = (name: string) => {
   const initials = (name || '').replace(/[^a-zA-Z0-9 ]/g, '').trim().split(' ').map(n => n[0]).join('')
   return initials[0]?.toUpperCase() ?? ''
}